import React from "react";

export const MCbrowser  = React.createContext({ });
